import React, { useEffect } from 'react';

import isUndefined from 'lodash/isUndefined';

import { WidgetState } from '../../ducks/type';

export function useWidgetCollapse(isInitiallyCollapsed: boolean | undefined, state: WidgetState['state']) {
    /*
     * A widget is "collapsible" only if `isCollapsed` is set at true.
     * The actual widget "collapsed" state is controlled internally via useState and
     * is set at true by default.
     *
     * `isCurrentlyCollapsed` is the actual collapsed state and will only be "true"
     * if the widget has both "isCollapsed" and "isCurrentlyCollapsed" at true.
     */
    const [isCurrentlyCollapsed, setCurrentlyCollapsed] = React.useState(isInitiallyCollapsed);
    useEffect(() => {
        if (state === 'loaded' && !isUndefined(isInitiallyCollapsed) && isUndefined(isCurrentlyCollapsed)) {
            setCurrentlyCollapsed(isInitiallyCollapsed);
        }
    }, [state, isInitiallyCollapsed, setCurrentlyCollapsed, isCurrentlyCollapsed]);
    const toggleCollapse = () => setCurrentlyCollapsed((wasCollapsed) => !wasCollapsed);
    return { isCurrentlyCollapsed, toggleCollapse };
}
